// src/components/Product-zone/Directory/TradersList.jsx
import React from "react";
import { tradersList } from "../Data/tradersList";
import TraderCard from "./TraderCard";

export default function TradersList() {
  return (
    <div className="flex min-h-full flex-col bg-slate-950 p-6 text-white">
      <div className="mb-6 text-center">
        <h1 className="text-3xl font-bold text-blue-400">Top Traders</h1>
        <p className="text-sm text-slate-400">
          Discover verified and active traders across global markets.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-6 sm:grid-cols-4 lg:grid-cols-6">
        {tradersList.map((trader) => (
          <TraderCard key={trader.id} trader={trader} />
        ))}
      </div>
    </div>
  );
}
